<template>
  <div :class="['checkbox-container', {'is-active' : isActive}]"
       @click="changeState">
    <div class="checkbox-content">
      <div class="img-container" v-if="isActive">
        <IconCheckbox/>
      </div>
    </div>
    <div class="title-container">
      {{ info.label }}
    </div>
  </div>
</template>

<script>
import IconCheckbox from "@/assets/icons/ui/checkbox.svg?inline"

export default {
  name: "Checkbox",
  components: { IconCheckbox },
  props: {
    value: Boolean,
    info: {
      type: Object,
      default: () => ({
        label: 'Value Label'
      })
    }
  },
  computed: {
    isActive() {
      return !!this.value
    }
  },
  methods: {
    changeState() {
      this.$emit('changeCheckbox', !this.value)
    }
  }
}
</script>


<style scoped lang="scss">
  .checkbox-container {
    display: flex;
    flex-direction: row;
    column-gap: 8px;
    align-items: center;
    cursor: pointer;
    @media(max-width: 769px) {
      align-items: flex-start;
      margin: 0;
    }
    &.is-active {
      .checkbox-content {
        border-color: var(--color-dark-green);
        background:  var(--color-dark-green);
      }
    }
    .title-container {
      font-size: 18px;
      color: var(--color-dark-green);
      @media(max-width: 769px) {
          font-size: 14px;
      }
    }
    .checkbox-content {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .3s ease;
      cursor: pointer;
      border-radius: 4px;
      width: 22px;
      height: 22px;
      border-width: 1px;
      border-style: solid;
      border-color: var(--color-dark-green);
      background:  var(--color-white);
      &:hover {
        border-color: var(--color-dark-green);
        background:  var(--color-dark-green);
      }
    }
  }
</style>